module.exports = __webpack_public_path__ + "img/icon-data02.49dc7a62.png";